export const appPromotionsConstants = {
  // Get
  GET_APP_PROMOTIONS_REQUEST: "GET_APP_PROMOTIONS__REQUEST",
  GET_APP_PROMOTIONS_SUCCESS: "GET_APP_PROMOTIONS__SUCCESS",
  GET_APP_PROMOTIONS_FAILURE: "GET_APP_PROMOTIONS__FAILURE"
};
